import React from 'react';

import './NoResults.scss';

const searchNoFoundImage = '/img/searchNoFound.png';

export interface NoResultsProps {
    translate: (key: string) => string;
}

export function NoResults({translate}: NoResultsProps): JSX.Element {
    return (
        <div className='history-console-no-results'>
            <div className='no-results-text-container'>
                <p className='no-results-title'>{translate('REACT.HISTORY_CONSOLE.NO_RESULTS_TITLE')}</p>
                <p className='no-results-subtitle'>{translate('REACT.HISTORY_CONSOLE.NO_RESULTS_SUBTITLE')}</p>
            </div>
            <img className='no-results-image' src={searchNoFoundImage} alt='No results found' />
        </div>
    );
}
